import styled from 'styled-components';
import { Typ30 } from 'dc/Typ';

export const ErrorText = styled(Typ30)`
  display: block;
  line-height: 20px;
  color: #e0487b;
  width: 288px;
  text-align: center;
  padding: 8px 0 8px 0;
`;
